import { render, staticRenderFns } from "./exam-record.vue?vue&type=template&id=878ff5bc&scoped=true&"
import script from "./exam-record.vue?vue&type=script&lang=js&"
export * from "./exam-record.vue?vue&type=script&lang=js&"
import style0 from "./exam-record.vue?vue&type=style&index=0&id=878ff5bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878ff5bc",
  null
  
)

export default component.exports